/* WebComponentLabelPrintingPageTemplateCreateEditTsx template */
import { h } from '@stencil/core';

const WebComponentLabelPrintingPageTemplateCreateEditTsx = (context) => {
  let I18N = context.ref.I18N;

  return (
      <dia-grid-nested>
        <dia-grid-row>
          <dia-grid-column>
            <dia-form>
              { /* @ts-ignore */}
              <form action="#" method="GET" name="dia-label-printing-page-template" has="validator">
                {context.ref.pageTemplateData && context.ref.pageTemplateData['template-id'] ?
                    <input type="hidden" name="template-id" value={context.ref.pageTemplateData['template-id']}/> : ''}
                <dia-form-line data-form-line-no-wrap>
                  <dia-form-control>
                    <input autocomplete="off" data-rules="required" onKeyUp={() => context.ref.autoRenderTemplateOnChange()} type="text"
                           name="template-desc" placeholder=""
                           value={context.ref.pageTemplateData ? context.ref.pageTemplateData['template-desc'] : ''}/>
                    <label>{ I18N.t('Bezeichnung') }</label>
                  </dia-form-control>
                  <dia-form-control>
                    <select autocomplete="off" data-rules={context.ref.pageTemplateData && context.ref.pageTemplateData['fields-validators']['page-format'] || false} name="page-format" onChange={async (event) => await context.ref.changePageFormat(event)}>
                      <option value="" disabled selected hidden></option>
                      {context.ref.pageTemplateDataFormat && Object.values(context.ref.pageTemplateDataFormat).map((format) =>
                          /* @ts-ignore */
                          <option value={format.key}
                                  /* @ts-ignore */
                                  selected={context.ref.pageTemplateData && context.ref.pageTemplateData['template-json'] && format.key === context.ref.pageTemplateData['template-json']['page-format']}>{format.label}</option>)}
                    </select>
                    <label>{ I18N.t('Seitenformat') }</label>
                  </dia-form-control>
                </dia-form-line>
                <dia-form-area>
                  <h3>{ I18N.t('Dimensionen') }</h3>
                  <dia-form-line data-form-line-no-wrap>
                    <dia-form-control>
                      <i data-icon-before="">mm</i>
                      <input
                        autocomplete="off"
                        data-rules={context.ref.pageTemplateData && 'number|' + context.ref.pageTemplateData['fields-validators']['width'] || false}
                        onKeyUp={() => context.ref.autoRenderTemplateOnChange()}
                        type="text"
                        name="width"
                        placeholder=""
                        data-icon
                        value={context.ref.pageTemplateData && context.ref.pageTemplateData['template-json'] && context.ref.pageTemplateData['template-json']['width'] ? String(context.ref.pageTemplateData['template-json']['width']) : ''}
                        readOnly={ context.ref.pageFormat !== "CUSTOM" }
                      />
                      <label>{ I18N.t('Seitenbreite') }</label>
                    </dia-form-control>
                    <dia-form-control>
                      <i data-icon-before="">mm</i>
                      <input
                        autocomplete="off"
                        data-rules={context.ref.pageTemplateData && 'number|' + context.ref.pageTemplateData['fields-validators']['height'] || false}
                        onKeyUp={() => context.ref.autoRenderTemplateOnChange()}
                        type="text"
                        name="height"
                        placeholder=""
                        data-icon
                        value={context.ref.pageTemplateData && context.ref.pageTemplateData['template-json'] && context.ref.pageTemplateData['template-json']['height'] ? String(context.ref.pageTemplateData['template-json']['height']) : ''}
                        readOnly={ context.ref.pageFormat !== "CUSTOM" }
                      />
                      <label>{ I18N.t('Seitenhöhe') }</label>
                    </dia-form-control>
                  </dia-form-line>
                </dia-form-area>
                <dia-form-area>
                  <h3>{ I18N.t('Seitenränder') }</h3>
                  <dia-form-line data-form-line-no-wrap>
                    <dia-form-control>
                      <i data-icon-before="">mm</i>
                      <input autocomplete="off" data-rules={context.ref.pageTemplateData && context.ref.pageTemplateData['fields-validators']['margin-top'] || false} onKeyUp={() => context.ref.autoRenderTemplateOnChange()}
                             type="text" name="margin-top" placeholder="" data-icon
                             value={context.ref.pageTemplateData ? String(context.ref.pageTemplateData['template-json']['margin-top']) : ''}/>
                      <label>{ I18N.t('oben') }</label>
                    </dia-form-control>
                    <dia-form-control>
                      <i data-icon-before="">mm</i>
                      <input autocomplete="off" data-rules={context.ref.pageTemplateData && context.ref.pageTemplateData['fields-validators']['margin-left'] || false} onKeyUp={() => context.ref.autoRenderTemplateOnChange()}
                             type="text" name="margin-left" placeholder="" data-icon
                             value={context.ref.pageTemplateData ? String(context.ref.pageTemplateData['template-json']['margin-left']) : ''}/>
                      <label>{ I18N.t('links') }</label>
                    </dia-form-control>
                  </dia-form-line>
                </dia-form-area>
                <dia-form-area>
                  <h3>{ I18N.t('Etikett Dimensionen') }</h3>
                  <dia-form-line data-form-line-no-wrap>
                    <dia-form-control>
                      <i data-icon-before="">mm</i>
                      <input autocomplete="off" data-rules={context.ref.pageTemplateData && 'number|' + context.ref.pageTemplateData['fields-validators']['label-width'] || false} onKeyUp={() => context.ref.autoRenderTemplateOnChange()}
                             type="text" name="label-width" placeholder="" data-icon
                             value={context.ref.pageTemplateData ? String(context.ref.pageTemplateData['template-json']['label-width']) : ''}
                             readOnly={ context.ref.pageTemplateData && context.ref.pageTemplateData['template-json'] && context.ref.pageTemplateData['template-json']['label-usage'] }
                      />
                      <label>{ I18N.t('Breite') }</label>
                    </dia-form-control>
                    <dia-form-control>
                      <i data-icon-before="">mm</i>
                      <input autocomplete="off" data-rules={context.ref.pageTemplateData && 'number|' + context.ref.pageTemplateData['fields-validators']['label-height'] || false} onKeyUp={() => context.ref.autoRenderTemplateOnChange()}
                             type="text" name="label-height" placeholder="" data-icon
                             value={context.ref.pageTemplateData ? String(context.ref.pageTemplateData['template-json']['label-height']) : ''}
                             readOnly={ context.ref.pageTemplateData && context.ref.pageTemplateData['template-json'] && context.ref.pageTemplateData['template-json']['label-usage'] }
                      />
                      <label>{ I18N.t('Höhe') }</label>
                    </dia-form-control>
                  </dia-form-line>
                </dia-form-area>
                <dia-form-area>
                  <h3>{ I18N.t('Etikett Anzahl') }</h3>
                  <dia-form-line data-form-line-no-wrap>
                    <dia-form-control>
                      <i data-icon-before=""></i>
                      <input autocomplete="off" data-rules={context.ref.pageTemplateData && context.ref.pageTemplateData['fields-validators']['label-nr-x'] || false} onKeyUp={() => context.ref.autoRenderTemplateOnChange()}
                             type="text" name="label-nr-x" placeholder="" data-icon
                             value={context.ref.pageTemplateData ? String(context.ref.pageTemplateData['template-json']['label-nr-x']) : ''}/>
                      <label>{ I18N.t('horizontal') }</label>
                    </dia-form-control>
                    <dia-form-control>
                      <i data-icon-before=""></i>
                      <input autocomplete="off" data-rules={context.ref.pageTemplateData && context.ref.pageTemplateData['fields-validators']['label-nr-y'] || false} onKeyUp={() => context.ref.autoRenderTemplateOnChange()}
                             type="text" name="label-nr-y" placeholder="" data-icon
                             value={context.ref.pageTemplateData ? String(context.ref.pageTemplateData['template-json']['label-nr-y']) : ''}/>
                      <label>{ I18N.t('vertikal') }</label>
                    </dia-form-control>
                  </dia-form-line>
                </dia-form-area>
                <dia-form-area>
                  <h3>{ I18N.t('Etiketten Abstand') }</h3>
                  <dia-form-line data-form-line-no-wrap>
                    <dia-form-control>
                      <i data-icon-before="">mm</i>
                      <input autocomplete="off" data-rules={context.ref.pageTemplateData && context.ref.pageTemplateData['fields-validators']['label-distance-x'] || false}
                             onKeyUp={() => context.ref.autoRenderTemplateOnChange()} type="text"
                             name="label-distance-x" placeholder="" data-icon
                             value={context.ref.pageTemplateData ? String(context.ref.pageTemplateData['template-json']['label-distance-x']) : ''}/>
                      <label>{ I18N.t('horizontal') }</label>
                    </dia-form-control>
                    <dia-form-control>
                      <i data-icon-before="">mm</i>
                      <input autocomplete="off" data-rules={context.ref.pageTemplateData && context.ref.pageTemplateData['fields-validators']['label-distance-y'] || false}
                             onKeyUp={() => context.ref.autoRenderTemplateOnChange()} type="text"
                             name="label-distance-y" placeholder="" data-icon
                             value={context.ref.pageTemplateData ? String(context.ref.pageTemplateData['template-json']['label-distance-y']) : ''}/>
                      <label>{ I18N.t('vertikal') }</label>
                    </dia-form-control>
                  </dia-form-line>
                </dia-form-area>
              </form>
            </dia-form>
          </dia-grid-column>
          <dia-grid-column>
            <dia-panel>
              <dia-panel-content>
                <picture>
                  {context.ref.templatePreview ? <img data-labelprint-preview
                                                      src={context.ref.templatePreview ? context.ref.templatePreview : ""}/> :
                      <img data-printing-preview-placeholder src={context.ref.getComponentAssetPath("/images/logo.svg")}
                           alt={ I18N.t('Platzhalter') } height="150"/>}
                </picture>
              </dia-panel-content>
            </dia-panel>
            <dia-form>
              <dia-form-line>
                <dia-form-control>
                  <button
                    data-secondary
                    data-icon-only
                    title={ I18N.t("Abbrechen") }
                    onClick={() => context.ref.pushRouterRoute(context.ref.getRouterRoute('PAGE_TEMPLATE_OVERVIEW'))}
                  >
                    <i data-dia-icon-before="cancel"></i>
                  </button>
                  <button
                    data-primary
                    data-icon-only
                    title={ I18N.t("Etikett speichern") }
                    onClick={() => context.ref.savePageTemplate()}
                    disabled={!context.ref.labelPrintingPageTemplateFormValid}
                  >
                    <i data-dia-icon-before="save"></i>
                  </button>
                </dia-form-control>
              </dia-form-line>
            </dia-form>
          </dia-grid-column>
        </dia-grid-row>
      </dia-grid-nested>
  )
};

export default WebComponentLabelPrintingPageTemplateCreateEditTsx;

